export default __webpack_public_path__ + "static/media/saab.6bd27496.svg";